/* eslint-disable import/no-unresolved */
/* eslint-disable simple-import-sort/imports */
import { Alert, ProtectedLazyRoute } from '@orientaction/commons';
import { useAlert } from '@orientaction/hooks';
import {
  AdminAddPassword,
  AdminCreateTest,
  AdminEbook1,
  AdminEbook3,
  AdminEbookUser,
  AdminEntreprise,
  Job,
  NotFound,
  ServerError,
  AdminTest,
  AdminUserHarmonyResult,
  AdminUserResultat,
  CreateBeneficiary,
  CreateConsultant,
  ConsultantProfile,
  BeneficiaryProfile,
  AddBeneficiaryPrestation,
  EditBeneficiaryPrestation,
  BeneficiaryModifyPassword,
  CreateEbook,
  CreateGame,
  CreateTest,
  CustomAuth,
  EditEbookMain,
  EditEbookPage,
  EditGame,
  EditPage,
  EditTest,
  EditVariable,
  Felicitations,
  ForgotPassword as ForgotPasswordCustom,
  GestionCategorie,
  GlobalRestitution,
  GlobalRestitutionAdmin,
  HarmonyRedirect,
  ListEbook,
  ListGame,
  Login as LoginCustom,
  Main,
  MesRessources,
  MesResultats,
  MinorTest,
  ModelVariable,
  MonResultat,
  MonResultatHarmony,
  MyTests,
  NeedsProResult,
  NeedsResult,
  PlayGame,
  PlayGameDisconnected,
  Profile,
  RedirectToLastResult,
  RedesignEbookDev,
  RedesignEbookDevStep2,
  RedesignEbookDevStep3,
  RedesignEbookDevStep4,
  RedesignEbookDevStep5,
  RedesignEbookIntro,
  RedesignEbookRecrutement,
  RedesignEbookCustom,
  RedesignEbookCustomEdit,
  RedesignSeriousGamePlay,
  RedesignSeriousGameView,
  RedesignSeriousGameSynthesis,
  ResetPassword as ResetPasswordCustom,
  Result,
  ResultatBeneficiaire,
  ResultatMeanning,
  ResultatPreference,
  ResultatPreferenceJeune,
  ResultatStudy,
  Resultats,
  Results,
  GoogleSSOCallback,
  FacebookSSOCallback,
  AppleSSOCallback,
  Signup,
  TestComponent,
  TestMeaningRedirect,
  TestNeedsProRedirect,
  TestNeedsRedirect,
  TestPageUser,
  TestPreferenceRedirect,
  TestPresentation,
  Test_Page,
  UserProfile,
  UserProfileEdit,
  Variables,
  ViewEbookDisconnected,
  ViewGame,
  AssistantIABeneficiaire,
  ConsultationPage,
  Statistics,
  ResultatPDF,
  AccountConfirm,
  VerifyPhone,
} from '@orientaction/pages';
import { Route, Switch } from 'react-router-dom';

import SelecteTemplate from '../pages/AdminSeriousGame';
import TestPageV2 from '../pages/v2/TestPageV2';
import RedesignMinorTestPresentation from '../pages/Redesign/Tests/Minor/Presentation';
import RedesignMinorTestPass from '../pages/Redesign/Tests/Minor/Pass';
import MajorTestPass from '../pages/Redesign/Tests/Major/Pass';
import TestComponentV2 from '../pages/v2/TestComponentV2';
import MinorTestCongrats from '../pages/Redesign/Tests/Minor/Congrats';
import MinorTestResults from '../pages/Redesign/Tests/Minor/Results';
import NoResponsePage from '../pages/v2/NoResponsePage';
import ActivateMatch from '../pages/ActivateMatch';
import AdminLeads from '../pages/AdminLeads';

const Router = () => {
  const alert = useAlert();

  const handleClose = () => {
    alert.setCloseAlert();
  };

  return (
    <>
      <Switch>
        <ProtectedLazyRoute path="/" exact={true} component={LoginCustom} />
        <ProtectedLazyRoute path="/signup" exact={true} component={Signup} />
        <ProtectedLazyRoute path="/signup/confirmation" exact={true} component={AccountConfirm} />
        <Route path="/auth/google-sso-callback" exact={true} component={GoogleSSOCallback} />
        <Route path="/auth/facebook-sso-callback" exact={true} component={FacebookSSOCallback} />
        <Route path="/auth/apple-sso-callback" exact={true} component={AppleSSOCallback} />
        <ProtectedLazyRoute path="/activate-match" exact={true} component={ActivateMatch} />
        <ProtectedLazyRoute path="/main" exact={true} component={Main} withIAChat={true} />
        <ProtectedLazyRoute path="/main/user/:id" exact={true} component={UserProfile} />
        <ProtectedLazyRoute path="/main/user/:id/edit" exact={true} component={UserProfileEdit} />
        <ProtectedLazyRoute path="/user/tests" exact={true} component={MyTests} withIAChat={true} />
        <ProtectedLazyRoute path="/profil" exact={true} component={Profile} />
        <ProtectedLazyRoute path="/results" component={Results} />
        <ProtectedLazyRoute path="/verify-phone" exact={true} component={VerifyPhone} />
        <ProtectedLazyRoute path="/forgot-password" exact={true} component={ForgotPasswordCustom} />
        <ProtectedLazyRoute path="/reset-password" exact={true} component={ResetPasswordCustom} />
        <ProtectedLazyRoute
          path="/admin/test"
          exact={true}
          component={AdminTest}
          isRootOnly={true}
        />
        <ProtectedLazyRoute
          path="/admin/game/selected"
          exact={true}
          component={SelecteTemplate}
          isRootOnly={true}
        />
        <ProtectedLazyRoute
          path="/admin/game/selected/:id"
          exact={true}
          component={SelecteTemplate}
          isRootOnly={true}
        />
        <ProtectedLazyRoute
          path="/admin/game/add-page/:id/:position?"
          exact={false}
          component={SelecteTemplate}
          isRootOnly={true}
        />
        <ProtectedLazyRoute
          path="/admin/test/:id/edit"
          exact={true}
          component={AdminCreateTest}
          isRootOnly={true}
        />
        <ProtectedLazyRoute
          path="/admin/game/list"
          exact={true}
          component={ListGame}
          isRootOnly={true}
        />
        <ProtectedLazyRoute
          path="/admin/game/create"
          exact={true}
          component={CreateGame}
          isRootOnly={true}
        />
        <ProtectedLazyRoute
          path="/admin/game/edit-page/:id"
          exact={true}
          component={EditPage}
          isRootOnly={true}
        />
        <ProtectedLazyRoute
          path="/admin/game/edit-page"
          exact={true}
          component={EditPage}
          isRootOnly={true}
        />
        <ProtectedLazyRoute
          path="/admin/game/create-variables/:edit?"
          exact={true}
          component={Variables}
          isRootOnly={true}
        />
        <ProtectedLazyRoute
          path="/admin/game/model-variable/:id/:edit?"
          exact={true}
          component={ModelVariable}
          isRootOnly={true}
        />
        <ProtectedLazyRoute
          path="/admin/game/edit-variable/:id/:edit?"
          exact={true}
          component={EditVariable}
          isRootOnly={true}
        />
        <ProtectedLazyRoute
          path="/admin/ebook/edit/:id"
          exact={true}
          component={RedesignEbookCustomEdit}
          isRootOnly={true}
        />
        <ProtectedLazyRoute
          path="/admin/ebook/edit"
          exact={true}
          component={RedesignEbookCustomEdit}
          isRootOnly={true}
        />
        <ProtectedLazyRoute
          path="/admin/ebook/edit/:id"
          exact={true}
          component={EditEbookPage}
          isRootOnly={true}
        />
        <ProtectedLazyRoute
          path="/admin/ebook/edit"
          exact={true}
          component={EditEbookPage}
          isRootOnly={true}
        />
        <ProtectedLazyRoute
          path="/admin/game/edit/:id"
          exact={true}
          component={EditGame}
          isRootOnly={true}
        />
        <ProtectedLazyRoute
          path="/game/view/:id/:idResult?"
          exact={true}
          component={RedesignSeriousGameView}
        />
        <ProtectedLazyRoute
          path="/game/play/:id/:idLastPage"
          exact={true}
          component={RedesignSeriousGamePlay}
        />
        <ProtectedLazyRoute
          path="/game/result/:idResult"
          exact={true}
          component={RedesignSeriousGameSynthesis}
          withIAChat={true}
        />
        <ProtectedLazyRoute
          path="/game/:id/:title?"
          exact={true}
          component={RedesignSeriousGameView}
        />
        <ProtectedLazyRoute
          path="/play/:id/:title?"
          exact={true}
          component={PlayGameDisconnected}
        />
        <ProtectedLazyRoute
          path="/admin/ebook/list"
          exact={true}
          component={ListEbook}
          isRootOnly={true}
        />
        <ProtectedLazyRoute
          path="/admin/ebook/create"
          exact={true}
          component={CreateEbook}
          isRootOnly={true}
        />
        <ProtectedLazyRoute
          path="/admin/ebook/edit-main/:id?"
          exact={true}
          component={EditEbookMain}
          isRootOnly={true}
        />
        <ProtectedLazyRoute
          path="/ebook/view/:id?/:index?"
          exact={true}
          component={RedesignEbookCustom}
        />
        <ProtectedLazyRoute
          path="/ebook/:id/:title?"
          exact={true}
          component={ViewEbookDisconnected}
        />
        <ProtectedLazyRoute path="/test" exact={true} component={Test_Page} withIAChat={true} />
        <ProtectedLazyRoute
          path="/resultats/:id"
          exact={true}
          component={Resultats}
          withIAChat={true}
        />
        <ProtectedLazyRoute
          path="/mon-resultat/:id"
          exact={true}
          component={Result}
          withIAChat={true}
        />
        <ProtectedLazyRoute
          path="/tests/soft-skills"
          exact={true}
          component={HarmonyRedirect}
          withIAChat={true}
        />
        <ProtectedLazyRoute
          path="/tests/preference-personality"
          exact={true}
          component={TestPreferenceRedirect}
          withIAChat={true}
        />
        <ProtectedLazyRoute
          path="/tests/needs-pro"
          exact={true}
          component={TestNeedsProRedirect}
          withIAChat={true}
        />
        <ProtectedLazyRoute
          path="/tests/needs"
          exact={true}
          component={TestNeedsRedirect}
          withIAChat={true}
        />
        <ProtectedLazyRoute
          path="/tests/meaning-value"
          exact={true}
          component={TestMeaningRedirect}
          withIAChat={true}
        />
        <ProtectedLazyRoute
          path="/tests/harmony"
          exact={true}
          component={MajorTestPass}
          withIAChat={true}
        />
        <ProtectedLazyRoute
          path="/:lang/tests/harmony"
          exact={true}
          component={MajorTestPass}
          withIAChat={true}
        />
        <ProtectedLazyRoute
          path="/tests/sens-valeurs"
          exact={true}
          component={MajorTestPass}
          withIAChat={true}
        />
        <ProtectedLazyRoute
          path="/:lang/tests/meaning-values"
          exact={true}
          component={MajorTestPass}
          withIAChat={true}
        />
        <ProtectedLazyRoute
          path="/tests/besoins"
          exact={true}
          component={MajorTestPass}
          withIAChat={true}
        />
        <ProtectedLazyRoute
          path="/:lang/tests/needs"
          exact={true}
          component={MajorTestPass}
          withIAChat={true}
        />
        <ProtectedLazyRoute
          path="/tests/besoins-pro"
          exact={true}
          component={MajorTestPass}
          withIAChat={true}
        />
        <ProtectedLazyRoute
          path="/:lang/tests/needs-pro"
          exact={true}
          component={MajorTestPass}
          withIAChat={true}
        />
        <ProtectedLazyRoute
          path="/tests/preferences-personnalites"
          exact={true}
          component={MajorTestPass}
          withIAChat={true}
        />
        <ProtectedLazyRoute
          path="/:lang/tests/preferences-personality"
          exact={true}
          component={MajorTestPass}
          withIAChat={true}
        />
        <ProtectedLazyRoute
          path="/tests/preferences-jeune"
          exact={true}
          component={MajorTestPass}
          withIAChat={true}
        />
        <ProtectedLazyRoute
          path="/:lang/tests/preferences-jeune"
          exact={true}
          component={MajorTestPass}
          withIAChat={true}
        />
        <ProtectedLazyRoute path="/tests/study" exact={true} component={MajorTestPass} />
        <ProtectedLazyRoute path="/:lang/tests/study" exact={true} component={MajorTestPass} />
        <ProtectedLazyRoute path="/tests" exact={true} component={TestPageUser} />
        <ProtectedLazyRoute path="/mes-resultats" exact={true} component={MesResultats} />
        <ProtectedLazyRoute path="/mes-resultats-pdf" exact={true} component={ResultatPDF} />
        <ProtectedLazyRoute path="/:lang/my-results" exact={true} component={MesResultats} />
        {/* <ProtectedLazyRoute
          path="/mes-resultats/:id/:idUser?"
          exact={true}
          component={TestStudy}
          withIAChat={true}
        /> */}
        <ProtectedLazyRoute
          path="/:lang/tests/study"
          exact={true}
          component={MajorTestPass}
          withIAChat={true}
        />
        <ProtectedLazyRoute path="/tests" exact={true} component={TestPageUser} withIAChat={true} />
        <ProtectedLazyRoute
          path="/mes-resultats"
          exact={true}
          component={MesResultats}
          withIAChat={true}
        />
        <ProtectedLazyRoute
          path="/:lang/my-results"
          exact={true}
          component={MesResultats}
          withIAChat={true}
        />
        <ProtectedLazyRoute
          path="/mes-resultats/:id/:idUser?"
          exact={true}
          component={MinorTestResults}
          withIAChat={true}
        />
        <ProtectedLazyRoute
          path="/admin/test/create-test"
          exact={true}
          component={AdminCreateTest}
          isRootOnly={true}
        />
        <ProtectedLazyRoute
          path="/admin/test/creer"
          exact={true}
          component={CreateTest}
          isRootOnly={true}
        />
        <ProtectedLazyRoute
          path="/admin/test/:id/modifier"
          exact={true}
          component={EditTest}
          isRootOnly={true}
        />
        <ProtectedLazyRoute
          path="/admin/users-resultats/creer-consultant"
          exact={true}
          isProtected={true}
          component={CreateConsultant}
        />
        <ProtectedLazyRoute
          path="/admin/users-resultats/creer-beneficiaire"
          exact={true}
          isProtected={true}
          component={CreateBeneficiary}
        />
        <ProtectedLazyRoute
          path="/admin/users-resultats/consultant/:id"
          exact={true}
          isProtected={true}
          component={ConsultantProfile}
        />
        <ProtectedLazyRoute
          path="/admin/users-resultats/beneficiaire/:id/ajouter-prestation"
          exact={true}
          isProtected={true}
          component={AddBeneficiaryPrestation}
        />
        <ProtectedLazyRoute
          path="/admin/users-resultats/beneficiaire/:id/prestation/:serviceId"
          exact={true}
          isProtected={true}
          component={EditBeneficiaryPrestation}
        />
        <ProtectedLazyRoute
          path="/admin/users-resultats/beneficiaire/:id"
          exact={true}
          isProtected={true}
          component={BeneficiaryProfile}
        />
        <ProtectedLazyRoute
          path="/admin/users-resultats"
          exact={true}
          isProtected={true}
          component={AdminUserResultat}
        />
        <ProtectedLazyRoute
          path="/admin/statistics"
          exact={true}
          isProtected={true}
          component={Statistics}
        />
        <ProtectedLazyRoute
          path="/admin/leads"
          exact={true}
          isProtected={true}
          component={AdminLeads}
        />
        <ProtectedLazyRoute
          path="/admin/business-spaces"
          exact={true}
          component={AdminEntreprise}
        />
        <ProtectedLazyRoute path="/admin/add-password" exact={true} component={AdminAddPassword} />
        <ProtectedLazyRoute
          path="/mes-ressources"
          exact={true}
          component={MesRessources}
          withIAChat={true}
        />
        <ProtectedLazyRoute
          path="/:lang/my-resources"
          exact={true}
          component={MesRessources}
          withIAChat={true}
        />
        <ProtectedLazyRoute
          path="/admin/resultat-beneficiaire/:id"
          exact={true}
          component={ResultatBeneficiaire}
        />
        <ProtectedLazyRoute
          path="/admin/ressources-beneficiaire/:id"
          exact={true}
          component={AdminEbookUser}
        />
        <ProtectedLazyRoute
          path="/admin/assistant-ia/:id/consultation/:consultationId"
          exact={true}
          component={ConsultationPage}
        />
        <ProtectedLazyRoute
          path="/admin/assistant-ia/:id"
          exact={true}
          component={AssistantIABeneficiaire}
        />
        <ProtectedLazyRoute path="/admin/ebook1-user/:id" exact={true} component={AdminEbook1} />
        <ProtectedLazyRoute path="/admin/ebook3" exact={true} component={AdminEbook3} />
        <ProtectedLazyRoute
          path="/ebook-intro/:id/:readOnly?/:index?"
          exact={true}
          component={RedesignEbookIntro}
        />
        <ProtectedLazyRoute
          path="/:lang/ebook-intro/:id/:readOnly?/:index?"
          exact={true}
          component={RedesignEbookIntro}
        />
        <ProtectedLazyRoute
          path="/ebook-etape-1/:id/:readOnly?/:index?"
          exact={true}
          component={RedesignEbookDev}
        />
        <ProtectedLazyRoute
          path="/:lang/ebook-step-1/:id/:readOnly?/:index?"
          exact={true}
          component={RedesignEbookDev}
        />
        <ProtectedLazyRoute
          path="/ebook-etape-2/:id/:readOnly?/:index?"
          exact={true}
          component={RedesignEbookDevStep2}
        />
        <ProtectedLazyRoute
          path="/:lang/ebook-step-2/:id/:readOnly?/:index?"
          exact={true}
          component={RedesignEbookDevStep2}
        />
        <ProtectedLazyRoute
          path="/ebook-etape-3/:id/:readOnly?/:index?"
          exact={true}
          component={RedesignEbookDevStep3}
        />
        <ProtectedLazyRoute
          path="/:lang/ebook-step-3/:id/:readOnly?/:index?"
          exact={true}
          component={RedesignEbookDevStep3}
        />
        <ProtectedLazyRoute
          path="/ebook-etape-4/:id/:readOnly?/:index?"
          exact={true}
          component={RedesignEbookDevStep4}
        />
        <ProtectedLazyRoute
          path="/:lang/ebook-step-4/:id/:readOnly?/:index?"
          exact={true}
          component={RedesignEbookDevStep4}
        />
        <ProtectedLazyRoute
          path="/ebook-etape-5/:id/:readOnly?/:index?"
          exact={true}
          component={RedesignEbookDevStep5}
        />
        <ProtectedLazyRoute
          path="/:lang/ebook-step-5/:id/:readOnly?/:index?"
          exact={true}
          component={RedesignEbookDevStep5}
        />

        <ProtectedLazyRoute
          path="/ebook-recrutement/:id/:readOnly?/:index?"
          exact={true}
          component={RedesignEbookRecrutement}
        />
        <ProtectedLazyRoute
          path="/:lang/ebook-recrutement/:id/:readOnly?/:index?"
          exact={true}
          component={RedesignEbookRecrutement}
        />
        <ProtectedLazyRoute
          path="/do-test/:id/:title?"
          exact={true}
          component={Test_Page}
          withIAChat={true}
        />
        <ProtectedLazyRoute
          path="/test/:id/passer/:title?"
          exact={true}
          component={RedesignMinorTestPass}
        />
        <ProtectedLazyRoute
          path="/test/:id/:title?"
          exact={true}
          component={RedesignMinorTestPresentation}
          withIAChat={true}
        />
        <ProtectedLazyRoute path="/v2/test" exact={true} component={TestPageV2} withIAChat={true} />
        <ProtectedLazyRoute
          path="/v2/test-component"
          exact={true}
          component={TestComponentV2}
          withIAChat={true}
        />
        <ProtectedLazyRoute
          path="/congrats/:id"
          exact={true}
          component={MinorTestCongrats}
          withIAChat={true}
        />
        <ProtectedLazyRoute
          path="/no-response"
          exact={true}
          component={NoResponsePage}
          withIAChat={true}
        />
        <ProtectedLazyRoute
          path="/admin/gestion-categorie"
          exact={true}
          component={GestionCategorie}
        />
        <ProtectedLazyRoute
          path="/resultat-harmony/:id"
          exact={true}
          component={MonResultatHarmony}
          withIAChat={true}
        />
        <ProtectedLazyRoute
          path="/resultat-harmony"
          exact={true}
          component={RedirectToLastResult}
          withIAChat={true}
        />
        <ProtectedLazyRoute
          path="/admin/user-harmony-result/:id"
          exact={true}
          component={AdminUserHarmonyResult}
        />
        <ProtectedLazyRoute
          path="/resultat-need-pro/:id"
          exact={true}
          component={NeedsProResult}
          withIAChat={true}
        />
        <ProtectedLazyRoute
          path="/resultat-needs-pro/:id"
          exact={true}
          component={NeedsProResult}
          withIAChat={true}
        />
        <ProtectedLazyRoute
          path="/resultat-need-pro"
          exact={true}
          component={RedirectToLastResult}
          withIAChat={true}
        />
        <ProtectedLazyRoute
          path="/resultat-preference/:id"
          exact={true}
          component={ResultatPreference}
          withIAChat={true}
        />
        <ProtectedLazyRoute
          path="/res-pref-j/:id"
          exact={true}
          component={ResultatPreferenceJeune}
          withIAChat={true}
        />
        <ProtectedLazyRoute
          path="/res-pref-j"
          exact={true}
          component={RedirectToLastResult}
          withIAChat={true}
        />
        <ProtectedLazyRoute
          path="/resultat-preference"
          exact={true}
          component={RedirectToLastResult}
          withIAChat={true}
        />
        <ProtectedLazyRoute
          path="/resultat-needs/:id"
          exact={true}
          component={NeedsResult}
          withIAChat={true}
        />
        <ProtectedLazyRoute
          path="/resultat-need/:id"
          exact={true}
          component={NeedsResult}
          withIAChat={true}
        />
        <ProtectedLazyRoute
          path="/resultat-need"
          exact={true}
          component={RedirectToLastResult}
          withIAChat={true}
        />
        <ProtectedLazyRoute
          path="/resultat-meaning-value/:id"
          exact={true}
          component={ResultatMeanning}
          withIAChat={true}
        />
        <ProtectedLazyRoute
          path="/resultat-meaning-value"
          exact={true}
          component={RedirectToLastResult}
          withIAChat={true}
        />
        <ProtectedLazyRoute
          path="/resultat-study/:id"
          exact={true}
          component={ResultatStudy}
          withIAChat={true}
        />
        <ProtectedLazyRoute
          path="/resultat-study"
          exact={true}
          component={RedirectToLastResult}
          withIAChat={true}
        />
        <ProtectedLazyRoute
          path="/mon-resultat-du-test-study/:id"
          exact={true}
          component={ResultatStudy}
          withIAChat={true}
        />
        <ProtectedLazyRoute
          path="/test-component"
          exact={true}
          component={TestComponent}
          withIAChat={true}
        />
        <ProtectedLazyRoute path="/ma-boussole/:year" exact={true} component={GlobalRestitution} />
        <ProtectedLazyRoute
          path="/:lang/my-compass/:year"
          exact={true}
          component={GlobalRestitution}
        />
        <ProtectedLazyRoute
          path="/admin/:userId/boussole/:year"
          exact={true}
          component={GlobalRestitutionAdmin}
        />
        <Route path="/user/modify-password" exact={true} component={BeneficiaryModifyPassword} />
        <ProtectedLazyRoute
          path="/resultat-test-besoins-pro"
          exact={true}
          component={CustomAuth}
          withIAChat={true}
        />
        <ProtectedLazyRoute
          path="/resultat-test-sens-valeurs"
          exact={true}
          component={CustomAuth}
          withIAChat={true}
        />
        <ProtectedLazyRoute
          path="/resultat-test-besoins"
          exact={true}
          component={CustomAuth}
          withIAChat={true}
        />
        <ProtectedLazyRoute
          path="/resultat-test-preferences"
          exact={true}
          component={CustomAuth}
          withIAChat={true}
        />
        <ProtectedLazyRoute
          path="/resultat-test-preferences"
          exact={true}
          component={CustomAuth}
          withIAChat={true}
        />
        <ProtectedLazyRoute
          path="/resultat-test-harmony"
          exact={true}
          component={CustomAuth}
          withIAChat={true}
        />
        <ProtectedLazyRoute
          path="/resultat-test-study"
          exact={true}
          component={CustomAuth}
          withIAChat={true}
        />

        <ProtectedLazyRoute path="/admin/emploi/board" exact={true} component={Job.Board} />
        <ProtectedLazyRoute
          path="/admin/emploi/candidats"
          exact={false}
          component={Job.Candidates}
        />
        <ProtectedLazyRoute path="/admin/emploi/annonces" exact={true} component={Job.Job} />
        <ProtectedLazyRoute path="/admin/emploi/annonces/:id" exact={true} component={Job.NewJob} />
        <ProtectedLazyRoute
          path="/admin/emploi/preview-annonce/:id"
          exact={true}
          component={Job.NewJobPreview}
        />
        <ProtectedLazyRoute
          path="/admin/emploi/voir-annonce/:id"
          exact={true}
          component={Job.DetailJob}
        />
        <ProtectedLazyRoute
          path="/admin/emploi/annonce/:id"
          exact={true}
          component={Job.JobCandidates}
        />
        <ProtectedLazyRoute
          path="/admin/emploi/detail-canditat/:id"
          exact={true}
          component={Job.DetailCandidat}
        />

        <Route path="/server-error" exact={true} component={ServerError} />
        <Route path="*" component={NotFound} />
      </Switch>

      <Alert
        open={alert.open}
        handleClose={handleClose}
        severity={alert.severity}
        message={alert.message}
        duration={alert.duration}
      />
    </>
  );
};

export default Router;
